import { Link } from 'react-router-dom';
import Button from '../components/common/Button';
import Card from '../components/common/Card';
import { featureFlags } from '../config/featureFlags';

export default function Home() {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-pink-light via-lavender-light to-mint-light py-20 md:py-32">
        <div className="container mx-auto px-4 text-center">
          <h1 className="font-serif text-5xl md:text-7xl text-gray-800 mb-4">
            We're Getting Married!
          </h1>
          <p className="text-xl md:text-2xl text-gray-700 mb-8 font-light">
            Join us for our special day
          </p>
          <div className="space-x-4">
            {featureFlags.rsvp && (
              <Link to="/rsvp">
                <Button variant="primary" className="text-lg">
                  RSVP Now
                </Button>
              </Link>
            )}
            <Link to="/details">
              <Button variant="secondary" className="text-lg">
                View Details
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Welcome Section */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4 max-w-4xl">
          <Card className="text-center">
            <h2 className="text-3xl md:text-4xl mb-6 text-pink">
              Welcome
            </h2>
            <p className="text-lg text-gray-700 mb-4 leading-relaxed">
              We're so excited to celebrate this special moment with you!
              This website has all the details you need about our wedding day.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Please take a moment to RSVP so we can plan accordingly.
              We can't wait to see you there!
            </p>
          </Card>
        </div>
      </section>

      {/* Quick Links Section */}
      <section className="py-16 bg-gradient-to-br from-mint-light to-pink-light">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl text-center mb-12 text-gray-800">
            Explore
          </h2>
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <Link to="/details" className="group">
              <Card className="h-full text-center group-hover:scale-105 transition-transform duration-200">
                <div className="text-4xl mb-4">📅</div>
                <h3 className="text-xl mb-2 text-lavender-dark">Event Details</h3>
                <p className="text-gray-600">When, where, and what to expect</p>
              </Card>
            </Link>
            {featureFlags.gallery && (
              <Link to="/gallery" className="group">
                <Card className="h-full text-center group-hover:scale-105 transition-transform duration-200">
                  <div className="text-4xl mb-4">📸</div>
                  <h3 className="text-xl mb-2 text-lavender-dark">Photo Gallery</h3>
                  <p className="text-gray-600">Our favorite moments together</p>
                </Card>
              </Link>
            )}
            {featureFlags.registry && (
              <Link to="/registry" className="group">
                <Card className="h-full text-center group-hover:scale-105 transition-transform duration-200">
                  <div className="text-4xl mb-4">🎁</div>
                  <h3 className="text-xl mb-2 text-lavender-dark">Registry</h3>
                  <p className="text-gray-600">Gift registries and preferences</p>
                </Card>
              </Link>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
